// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xm_a bhr_vp bhr_vh bhr_xe bhr_rg bhr_tr bhr_qx"};